import getUrl from './getUrl.js';

export default function singleListing(idDeal) {
    return fetch(`${getUrl()}/v2/deal/${idDeal}`, {
      method: 'GET',
      headers: {
        'Content-type':'application/json'
      },
      credentials: 'include',
    })
    .then((res) => res.json())
  }